// Dependecias
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';
import { loadLoader } from '../utils/loader';

// Services
import * as clientService from '../service/client.service';

// Configuraciones
import { alertConfigurations } from '../config/sweetAlert.config';
import {
  VerificationMessages,
  OptionsMessages
} from '../config/Messages.config';

// Elementos HTML
const formUser = document.querySelector<HTMLFormElement>('#form-user')!;
const btnBlockUser = document.querySelector<HTMLButtonElement>('#block');
const btnUnblockUser = document.querySelector<HTMLButtonElement>('#unblock');
const btnVerify = document.querySelector<HTMLButtonElement>('#verify')!;
const btnReject = document.querySelector<HTMLButtonElement>('#reject')!;
const containerImagesElement =
  document.querySelector<HTMLDivElement>('#container-images')!;
const btnsToEdit = document.querySelectorAll<HTMLButtonElement>('.btn-edit');
const currentImage =
  document.querySelector<HTMLImageElement>('#current-image')!;
const inputsData = document.querySelectorAll<HTMLInputElement>('input');
const textInputs = formUser.querySelectorAll<HTMLInputElement>('.form-control');
const currentImageModal = new Modal('#exampleModal', {
  keyboard: true
});
const okStatusCode = 299;

let currentValueEdit: string | null = null;

export function main() {
  document.addEventListener('DOMContentLoaded', async() => {
    await Promise.all([
      (() => {
        const images = Object.values(containerImagesElement?.dataset ?? {});
        const thereAreImages = images
          .map((urlImage) => !!urlImage)
          .some(Boolean);

        if (thereAreImages) {
          images.forEach((image) => {
            const img = new Image();
            const canvas = document.createElement('canvas');
            const div = document.createElement('div');
            const ctx = canvas.getContext('2d')!;

            canvas.classList.add('w-100');
            canvas.height = 325;
            canvas.style.cursor = 'pointer';

            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            img.src = image!;
            img.addEventListener('load', () => {
              const scale = img.height / img.width;
              const height = canvas.height * scale;
              const y = canvas.height / 2 - height / 2;
              ctx.drawImage(img, 0, y, canvas.width, height);
            });

            canvas.addEventListener('click', () => {
              currentImage.src = image!;
              currentImageModal.show();
            });

            // Pinto o creo los divs para las imagesnes
            div.classList.add('col-4');
            div.appendChild(canvas);

            containerImagesElement.appendChild(div);
          });
        }
      })(),
      (() => {
        btnsToEdit.forEach((btn) => {
          btn.addEventListener('click', async(e) => {
            const btnTarget = e.target as HTMLButtonElement;
            const containerBtn = btnTarget.parentElement as HTMLDivElement;
            const type = btnTarget.dataset.type as ActionType;
            const input = containerBtn.querySelector('input')!;
            currentValueEdit = input.value;

            // Valido la accion para editar la informacion del usuario
            if (type === ActionType.EDIT) {
              // Cambio el Estatus del boton y el input
              btnTarget.classList.remove('btn-primary');
              btnTarget.classList.add('btn-success');
              btnTarget.innerHTML = 'Guardar <i class="bi bi-floppy"></i>';
              btnTarget.dataset.type = 'save';
              input.disabled = false;
              input.focus();
              return;
            }

            // Guardo la informacion del usuario
            const {
              id,
              email,
              last_name: lastname,
              name
            } = Object.fromEntries(new FormData(formUser)) as UserForm;

            loadLoader({});
            const responce = await clientService.updateUser({
              params: {
                id,
                email,
                last_name: lastname,
                name
              }
            });
            loadLoader({ start: false });
            if (responce <= okStatusCode) {
              await Swal.fire({
                ...alertConfigurations,
                confirmButtonText: OptionsMessages.ACEPTAR,
                showDenyButton: false,
                title: '¡Éxito!',
                text: 'La información se ha actualizado correctamente',
                icon: 'success'
              });
            }

            // Cambio el Estatus del boton y el input
            btnTarget.classList.remove('btn-success');
            btnTarget.classList.add('btn-primary');
            btnTarget.innerHTML = 'Editar <i class="bi bi-pencil"></i>';
            btnTarget.dataset.type = 'edit';
            input.disabled = true;
          });
        });
      })()
    ]);
  });

  // Accion para bloquear o desbloquear un usuario
  [btnBlockUser, btnUnblockUser].forEach((btn) => {
    btn?.addEventListener('click', async() => {
      const {
        id,
        last_name: lastname,
        name
      } = Object.fromEntries(new FormData(formUser)) as UserForm;

      const message = VerificationMessages[
        btn === btnBlockUser ? 'BLOCK' : 'UNBLOCK'
      ].replace('<nombre>', `${name} ${lastname}`);
      const result = await Swal.fire({
        ...alertConfigurations,
        title: 'Confirmación',
        text: message,
        icon: 'info'
      });

      // Se Valida si se realizara la accion
      if (!result.isConfirmed) return;

      loadLoader({});
      const statusCode = await clientService.changeStatusUser({
        type:
          btn === btnBlockUser
            ? clientService.ActionTypesStatus.BLOCK
            : clientService.ActionTypesStatus.UNBLOCK,
        params: { id }
      });
      if (statusCode <= okStatusCode) {
        await Swal.fire({
          ...alertConfigurations,
          confirmButtonText: OptionsMessages.ACEPTAR,
          showDenyButton: false,
          title: '¡Éxito!',
          text: 'Accion realizada correctamente',
          icon: 'success'
        });

        window.location.reload();
      }
    });
  });

  // Accion para verificar un usuario
  btnVerify?.addEventListener('click', async() => {
    const { id } = Object.fromEntries(new FormData(formUser)) as UserForm;

    const result = await Swal.fire({
      ...alertConfigurations,
      title: 'Verificación de Usuario',
      text: VerificationMessages.VERIFY,
      icon: 'info'
    });

    if (!result.isConfirmed) return;

    loadLoader({});
    const responce = await clientService.changeVeryRejectStatus({
      type: clientService.ActionTypesStatus.VERIFY,
      params: { id, verificado: 'true' }
    });

    if (responce <= okStatusCode) {
      await Swal.fire({
        ...alertConfigurations,
        confirmButtonText: OptionsMessages.ACEPTAR,
        showDenyButton: false,
        title: '¡Éxito!',
        text: 'Accion realizada correctamente',
        icon: 'success'
      });

      window.location.reload();
    }
  });

  // Accion para rechazar la verificación de un usuario
  btnReject?.addEventListener('click', async() => {
    const { id } = Object.fromEntries(new FormData(formUser)) as UserForm;

    const rejectConfirmation = await Swal.fire({
      ...alertConfigurations,
      title: 'Rechazo de Verificación',
      text: '¿Estás seguro de rechazar la verificación de este usuario?',
      icon: 'info'
    });

    if (!rejectConfirmation.isConfirmed) return;

    const rejectReason = await Swal.fire<string>({
      ...alertConfigurations,
      denyButtonText: OptionsMessages.CANCELAR,
      confirmButtonText: OptionsMessages.ACEPTAR,
      title: 'Motivo de Rechazo',
      input: 'textarea',
      icon: 'question',
      inputPlaceholder: 'Escribe el motivo de rechazo',
      inputValidator: (value) =>
        (!value || value.length <= 5) && 'Debes escribir el motivo de rechazo'
    });

    if (!rejectReason.isConfirmed) return;

    loadLoader({});
    const responce = await clientService.changeVeryRejectStatus({
      type: clientService.ActionTypesStatus.REJECT,
      params: { id, reason: rejectReason.value! }
    });

    if (responce <= okStatusCode) {
      await Swal.fire({
        ...alertConfigurations,
        confirmButtonText: OptionsMessages.ACEPTAR,
        showDenyButton: false,
        title: '¡Éxito!',
        text: 'Accion realizada correctamente',
        icon: 'success'
      });

      window.location.reload();
    }
  });

  inputsData.forEach((input) => {
    input.addEventListener('focusout', (e) => {
      const inputTarget = e.target as HTMLInputElement;
      const containerBtn = inputTarget.parentElement as HTMLDivElement;
      const button = containerBtn.querySelector('button')!;
      const name = inputTarget.id.split('-')[2];
      const input = formUser.querySelector<HTMLInputElement>(
        `[name="${name}"]`
      )!;

      // Valido que no apriete el boton de guardar
      if (button === e.relatedTarget) return;

      button.classList.remove('btn-success');
      button.classList.add('btn-primary');
      button.innerHTML = 'Editar <i class="bi bi-pencil"></i>';
      button.dataset.type = 'edit';
      inputTarget.disabled = true;
      inputTarget.value = currentValueEdit!;
      input.value = currentValueEdit!;
    });
  });

  textInputs.forEach((input) =>
    input.addEventListener('keyup', (e) => {
      const inputTarget = e.target as HTMLInputElement;
      const name = inputTarget.id.split('-')[2];
      const input = formUser.querySelector<HTMLInputElement>(
        `[name="${name}"]`
      )!;

      input.value = inputTarget.value;
    })
  );
}

// Definicion de Tipos e interfaces
type UserForm = {
  readonly id: string;
  readonly name: string;
  readonly last_name: string;
  readonly email: string;
};

enum ActionType {
  SAVE = 'save',
  EDIT = 'edit',
}
